export const leftBarData = [
    { name: "Ana Sayfa", url: "/", imageUrl: "faHome", target: "_self" },
    { name: "Haberler", url: "/haberler", imageUrl: "faHome", target: "_self" },
    { name: "Hakkımızda", url: "/hakkimizda", imageUrl: "faHome", target: "_self" },
    { name: "Düzenleme Kurulu", url: "/duzenleme", imageUrl: "faHome", target: "_self" },
    { name: "Sponsorluk Bilgileri", url: "/sponsorlukbilgileri", imageUrl: "faHome", target: "_self" },
    { name: "Kariyer Merkezleri", url: "/kariyermerkezleriiletisim", imageUrl: "faHome", target: "_self" },
    { name: "Katılımcı Ol", url: "/katilimciolbilgileri", imageUrl: "faHome", target: "_self" },
]